






import {Action, Getter} from 'vuex-class'
import BaseComponent from '@/components/base/BaseComponent'
import {Prop} from 'vue-property-decorator'
import Component from 'vue-class-component'
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";

@Component({})
export default class LogoutComponent extends BaseComponent {

    private labelProp!: string

    @Action('logout', StoreNamespace.AUTHORIZATION) logout: any
    @Action('resetStore') resetStore: any
    @Getter('mngCompanyName', StoreNamespace.AUTHENTICATION) mngCompanyName!: string

    @Prop() label!: string

    mounted() {
        this.labelProp = this.label
    }

    doLogout(): void {
        this.logout({requestorCallback: this})
    }

    onSuccess(data?: any, requestName?: any, message?: string) {
        this.resetStore()
        if (this.mngCompanyName) {
            this.$router.push('/login/' + this.mngCompanyName)
        } else {
            this.$router.push({name: 'success-logout'})
        }
    }
}
